import {
  TREQUEST_FabricGRNLotDetails,
  TREQUEST_FabricGRNLotListing,
  TRESPONSE_FabricGRNLotDetails,
  TRESPONSE_FabricGRNLotListing,
  TREQUEST_TrimsGRNLotListing,
  TRESPONSE_TrimsGRNLotListing,
  TREQUEST_TrimsGRNLotDetails,
  TRESPONSE_TrimsGRNLotDetails,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum CreateGRNActions {
  ClearAndFetchFabricCreateGRNLotListing = 'ClearAndFetchFabricCreateGRNLotListing',
  ClearAndFetchFabricCreateGRNLotListingSuccess = 'ClearAndFetchFabricCreateGRNLotListingSuccess',
  ClearAndFetchTrimsCreateGRNLotListing = 'ClearAndFetchTrimsCreateGRNLotListing',
  ClearAndFetchTrimsCreateGRNLotListingSuccess = 'ClearAndFetchTrimsCreateGRNLotListingSuccess',

  ClearAndFetchFabricCreateGRNLotDetails = 'ClearAndFetchFabricCreateGRNLotDetails',
  ClearAndFetchFabricCreateGRNLotDetailsSuccess = 'ClearAndFetchFabricCreateGRNLotDetailsSuccess',
  ClearAndFetchTrimsCreateGRNLotDetails = 'ClearAndFetchTrimsCreateGRNLotDetails',
  ClearAndFetchTrimsCreateGRNLotDetailsSuccess = 'ClearAndFetchTrimsCreateGRNLotDetailsSuccess',

  CreateGRNNoAction = 'CreateGRNNoAction',
}

export class ClearAndFetchFabricCreateGRNLotListing implements Action {
  readonly type = CreateGRNActions.ClearAndFetchFabricCreateGRNLotListing;
  constructor(public payload: TREQUEST_FabricGRNLotListing) {}
}

export class ClearAndFetchFabricCreateGRNLotListingSuccess implements Action {
  readonly type = CreateGRNActions.ClearAndFetchFabricCreateGRNLotListingSuccess;
  constructor(public res: TRESPONSE_FabricGRNLotListing) {}
}

export class ClearAndFetchTrimsCreateGRNLotListing implements Action {
  readonly type = CreateGRNActions.ClearAndFetchTrimsCreateGRNLotListing;
  constructor(public payload: TREQUEST_TrimsGRNLotListing) {}
}

export class ClearAndFetchTrimsCreateGRNLotListingSuccess implements Action {
  readonly type = CreateGRNActions.ClearAndFetchTrimsCreateGRNLotListingSuccess;
  constructor(public res: TRESPONSE_TrimsGRNLotListing) {}
}

export class ClearAndFetchFabricCreateGRNLotDetails implements Action {
  readonly type = CreateGRNActions.ClearAndFetchFabricCreateGRNLotDetails;
  constructor(public payload: TREQUEST_FabricGRNLotDetails) {}
}

export class ClearAndFetchFabricCreateGRNLotDetailsSuccess implements Action {
  readonly type = CreateGRNActions.ClearAndFetchFabricCreateGRNLotDetailsSuccess;
  constructor(public res: TRESPONSE_FabricGRNLotDetails) {}
}

export class ClearAndFetchTrimsCreateGRNLotDetails implements Action {
  readonly type = CreateGRNActions.ClearAndFetchTrimsCreateGRNLotDetails;
  constructor(public payload: TREQUEST_TrimsGRNLotDetails) {}
}

export class ClearAndFetchTrimsCreateGRNLotDetailsSuccess implements Action {
  readonly type = CreateGRNActions.ClearAndFetchTrimsCreateGRNLotDetailsSuccess;
  constructor(public res: TRESPONSE_TrimsGRNLotDetails) {}
}

export class CreateGRNNoAction implements Action {
  readonly type = CreateGRNActions.CreateGRNNoAction;
  constructor() {}
}

export type TCreateGRNActionTypes =
  | ClearAndFetchFabricCreateGRNLotListing
  | ClearAndFetchFabricCreateGRNLotListingSuccess
  | ClearAndFetchTrimsCreateGRNLotListing
  | ClearAndFetchTrimsCreateGRNLotListingSuccess
  | ClearAndFetchFabricCreateGRNLotDetails
  | ClearAndFetchFabricCreateGRNLotDetailsSuccess
  | ClearAndFetchTrimsCreateGRNLotDetails
  | ClearAndFetchTrimsCreateGRNLotDetailsSuccess
  | CreateGRNNoAction;
